import Vue from 'vue';
import {
  LinkCellRenderer,
  autoResize,
  ProgressBarRenderer,
  getPinnedRowData
} from '@/helpers/renderHelpers';
import {
  addColIdToColumns,
  SumRows
} from '@/helpers/commonHelpers';
import gridProps from '@/gridProps';

export default {
  namespaced: true,
  state: {
    orderItemsColumns: [],
    orderItems: [],
    orderItemsCount: '',
    pinnedRowData: [{}],
    packageDescriptions: [],
    qualityDesc: [],
    progressPerMovement: [],
    profileDesc: [],
    purposes: [],
    gridOptions: {
      rowGroupPanelShow: 'always',
      animateRows: true,
      rowSelection: 'multiple',
      aggFuncs: {
        'SumRows': SumRows
      },
      components: {
        'ContractLink': LinkCellRenderer('contract_id', '/contracts/'),
        'PurchaseOrderLink': LinkCellRenderer('purchase_order_id', '/purchaseOrders/'),
        'ProgressBar': ProgressBarRenderer(),
        'SupplierLink': LinkCellRenderer('shipper_id', '/partners/'),
        'AgentLink': LinkCellRenderer('agent_id', '/partners/')
      },
      getRowStyle: function (params) {
        if (params.data && !params.data.twl_nominal && !params.node.rowPinned) {
          return {background: '#FCCEC4'}
        }
      },
      defaultColDef: {
        sortable: true,
        filter: true,
        resizable: true
      },
      onRowDataChanged() {
        if (this.rowData && this.rowData.length) {
          autoResize(this);
        } else {
          this.api && this.api.hideOverlay();
          this.api && this.api.showNoRowsOverlay();
        }
      }
    },
    gridName: ''
  },
  getters: {
    gridOptions(state) {
      return {...state.gridOptions, ...gridProps};
    }
  },
  mutations: {
    setItems(state, data) {
      if (data.data) {
        state.orderItems = data.data.results;
        state.orderItemsCount = data.data.count;
        state.orderItemsColumns = addColIdToColumns(data.used_columns);
        state.pinnedRowData = getPinnedRowData(data.total,'name','value');
      } else {
        state.orderItems = data;
        state.pinnedRowData = data;
      }
      if (data.grid_name) {
        state.gridName = data.grid_name;
      }
    },
    setPackageDescriptions(state, data) {
      state.packageDescriptions = data;
    },
    setQualityDesc(state, data) {
      state.qualityDesc = data;
    },
    setProfileDesc(state, data) {
      state.profileDesc = data;
    },
    setPurposes(state, data) {
      state.purposes = data;
    }
  },
  actions: {
    loadOrderItems(store, payLoad) {
      if (store.getters.gridOptions.api) {
        store.getters.gridOptions.api.showLoadingOverlay();
      }
      Vue.http.get('purchase/search_for_order_items/', {params: payLoad})
        .then(response => response.json())
        .then(data => {
          store.commit('setItems', data);
        });
    },
    async loadQualityDescriptions(store, payLoad) {
      try {
        const data = await Vue.http.get('purchase/quality_desc/', {params: payLoad}).then(response => response.json());
        store.commit('setQualityDesc', data);
      } catch (exception) {
        console.log(exception);
      }
    },
    loadPackageDescriptions(store, payLoad) {
      Vue.http.get('purchase/baling/', {params: payLoad})
        .then(response => response.json())
        .then(data => {
          store.commit('setPackageDescriptions', data);
        });
    },
    loadProfileDesc(store, payLoad) {
      Vue.http.get('purchase/profile_desc/', {params: payLoad})
        .then(response => response.json())
        .then(data => {
          store.commit('setProfileDesc', data);
        });
    },
    loadPurposes(store, payLoad) {
      Vue.http.get('purchase/purposes/', {params: payLoad})
        .then(response => response.json())
        .then(data => {
          store.commit('setPurposes', data);
        });
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/purchases/order-items/purchaseOrderItems.js